import useHttp from "hooks/useHttp";
import useCommissionDashboard from "hooks/useCommissionDashboard";
import { useState } from "react";
import CommissionSettingsPanel from "./components/CommissionSettingsPanel";
import CommissionsKpiCards from "./components/CommissionsKpiCards";
import CommissionsSourceTabs from "./components/CommissionsSourceTabs";
import CommissionsSourcePanel from "./components/CommissionsSourcePanel";
import CommissionsLogTable from "./components/CommissionsLogTable";

export default function CommissionsPage() {
  const api = useHttp();
  const { summary, isLoading, error, retry } = useCommissionDashboard(api);
  const [activeSource, setActiveSource] = useState("fc_motivate");

  return (
    <>
      <h2 className="text-lg font-medium text-gray-900 mb-4">Commissions</h2>

      <CommissionSettingsPanel api={api} onSaved={() => retry({ silent: true })} />

      <CommissionsKpiCards
        totalOwed={summary.totalOwedThisMonth}
        totalPaid={summary.totalPaidThisMonth}
        isLoading={isLoading}
      />

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-6">
        <div className="px-4 py-3 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Commission Sources</h3>
        </div>
        <CommissionsSourceTabs
          activeSource={activeSource}
          onChange={setActiveSource}
          fcMotivate={summary.fcMotivate}
          fcMotivatePercentage={summary.fcMotivatePercentage}
          emailManager={summary.emailManager}
          saleTeam={summary.saleTeam}
          aceProgress={summary.aceProgress}
        />
        <CommissionsSourcePanel
          source={activeSource}
          fcMotivate={summary.fcMotivate}
          fcMotivatePercentage={summary.fcMotivatePercentage}
          emailManager={summary.emailManager}
          saleTeam={summary.saleTeam}
          aceProgress={summary.aceProgress}
          isLoading={isLoading}
        />
      </div>

      <CommissionsLogTable
        commissionLog={summary.commissionLog}
        isLoading={isLoading}
        error={error}
        onRetry={retry}
      />
    </>
  );
}
